import { PlaceDetail } from '../../../../services/locations.service';
import { TemplateKey } from '../template/suburb-template';

/**
 * What the Suburbs workspace's side panel shows (#256). One panel at a time; `null` is closed. A new panel is a new
 * member of this union, a title in suburb-side-panel.component.html and a body there (README.md, "Adding a panel").
 */
export type Panel =
  | { kind: 'suburb'; salCode: string; tab: SuburbTab }
  | { kind: 'subregion'; id: string }
  | { kind: 'regions' }
  | { kind: 'region-edit'; title: string }
  | { kind: 'other-pages' }
  | { kind: 'page-edit'; title: string }
  | { kind: 'place'; salCode: string; locationId: number }
  | { kind: 'place-new'; salCode: string; title: string }
  | { kind: 'place-edit'; salCode: string; locationId: number; place: PlaceDetail; title: string }
  | { kind: 'pending' }
  /** The Suburb or Sub-region page template's editor (#262). */
  | { kind: 'template'; key: TemplateKey; title: string };

/** A suburb's panel tabs (#256, #253, #254). A new tab is a member here and in SUBURB_TABS, and a body in the panel. */
export type SuburbTab = 'overview' | 'places' | 'data' | 'notes' | 'page' | 'drafts';

export const SUBURB_TABS: ReadonlyArray<{ id: SuburbTab; label: string }> = [
  { id: 'overview', label: 'Overview' },
  { id: 'places', label: 'Places' },
  { id: 'data', label: 'Data' },
  { id: 'notes', label: 'Our data' },
  { id: 'page', label: 'Page' },
  { id: 'drafts', label: 'Drafts' },
];

/**
 * The stage's views (#256, #262): the map, the List of every suburb, or Readiness (one row per suburb page: what it
 * has, what's missing, its owner and status). A new view is a member here and in WORKSPACE_VIEWS, and its own block in
 * the workspace's stage. 'preview' (#263) is the one view not in the switch: an editor in the side panel enters it
 * (StagePreviewService).
 */
export type WorkspaceView = 'map' | 'list' | 'readiness' | 'preview';

export const WORKSPACE_VIEWS: Array<{ label: string; value: WorkspaceView }> = [
  { label: 'Map', value: 'map' },
  { label: 'List', value: 'list' },
  { label: 'Readiness', value: 'readiness' },
];
